<div class="alert alert-warning" role="alert">
  <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="mr-1"></jhi-bary-icon>
  <span class="warning">
    {{ (options.isPickup ? 'LOADING_CONSTRAINT.MESSAGE.PICKUP.WARNING' : 'LOADING_CONSTRAINT.MESSAGE.DELIVERY.WARNING') | translate }}
  </span>
</div>
<div class="d-flex flex-column align-items-start" *ngIf="transport?.isFTL()">
  <jhi-bary-title titleKey="LOADING_CONSTRAINT.VEHICLE.TITLE"></jhi-bary-title>
  <p>{{ getVehicleData() }}</p>
</div>
<jhi-bary-options-selector
  [label]="switchCase('LOADING_CONSTRAINT.PICKUP.LABEL' | translate, 'LOADING_CONSTRAINT.DELIVERY.LABEL' | translate)"
  [titleKey]="switchCase('LOADING_CONSTRAINT.PICKUP.TITLE', 'LOADING_CONSTRAINT.DELIVERY.TITLE')"
  [control]="control"
  justifyContent="justify-content-start"
  [tooltip]="(transport?.isFTL() ? switchCase('LOADING_CONSTRAINT.PICKUP.TOOLTIP', 'LOADING_CONSTRAINT.DELIVERY.TOOLTIP') : '') | translate"
  [options]="loadingConstraints"
></jhi-bary-options-selector>
